export const DEFAULT_COOKIE_NAME = 'cookie_layer';
export const STORAGE_COOKIE_NAME = 'cookieSettings';
export const COOKIE_EXPIRATION_DAYS = 365;
export const REMOVE_COOKIES_INTERVAL = 30000;
